import { createQueryKeys } from "@lukemorales/query-key-factory";
import getAddressPredictions from "./address-predictions.client";
import { getCurrentLocation } from "./geocoding.client";
import { getPlaceDetails } from "./google-places.client";
import {
  getPlaceDetails as getPlaceDetailsData,
  getPlaceIdFromPostalCode,
} from "./place-details.client";
import getPostalCodePredictions from "./postal-codes.client";
import getVenuePredictions from "./venue-predictions.client";

export const location = createQueryKeys("location", {
  postalCodePredictions: ({ postalCode }: { postalCode: string }) => ({
    queryKey: ["postal-code-predictions", postalCode],
    queryFn: () => getPostalCodePredictions(postalCode),
  }),
  venuePredictions: ({ query }: { query: string }) => ({
    queryKey: ["venue-predictions", query],
    queryFn: () => getVenuePredictions(query),
  }),
  addressPredictions: ({ query }: { query: string }) => ({
    queryKey: ["address-predictions", query],
    queryFn: () => getAddressPredictions(query),
  }),
  placeDetails: ({ placeId }: { placeId: string }) => ({
    queryKey: ["google-places", "place-details", placeId],
    queryFn: () => getPlaceDetails(placeId),
  }),
  placeDetailsData: ({ placeId }: { placeId: string }) => ({
    queryKey: ["google-places", "place-details-data", placeId],
    queryFn: () => getPlaceDetailsData(placeId),
  }),
  placeIdFromPostalCode: ({ postalCode }: { postalCode: string }) => ({
    queryKey: ["google-places", "place-id", postalCode],
    queryFn: () => getPlaceIdFromPostalCode(postalCode),
  }),
  currentLocation: () => ({
    queryKey: ["current-location"],
    queryFn: () => getCurrentLocation(),
  }),
});
